// 引入type常量
import {
    SWITCH_LEFT_NAV,
} from "../actionType/index";


//切换左侧导航
export const switchLeftNav = (activeLeftNav) => {
    return {type: SWITCH_LEFT_NAV, activeLeftNav}
};



// WEBPACK FOOTER //
// ./src/store/actionDispatch/index.js